import React, { useMemo } from 'react';
import clsx from 'clsx';
import style from '../style.module.scss';
import Url from 'environment';
import { _SOCCER_TIME_LINE } from 'common/constants/sportsConstants';

const SoccerTimeLineItem = ({ item }) => {
  const { eventType, locationType, playText, score, displayTime } = item;

  const eventClass = useMemo(() => {
    /**
     * "GOAL"
     * "YELLOW_CARD"
     * "PK_SUCCESS" //패널티킥 성공
     * "OWN_GOAL" //자책점
     * "RED_CARD"
     * "YELLOW_TO_RED" //경고 누적으로 인한 퇴장
     * "PK_FAIL" //패널티킥 실패
     * "SHOOTOUT_FIRST_SHOOTING_TEAM_INDICATE"  //승부차기 선제권 팀 표시를 위한 타입
     * "SHOOTOUT_SUCCESS" //승부차기 성공
     * "SHOOTOUT_FAIL" //승부차기 실패
     * "HALFTIME" //전반 종료 알림을 위한 타입
     * "FULLTIME" //후반 종료 알림을 위한 타입
     * "SUBSTITUTE" //교체
     * "NORMAL" //그외-캐스터에서 삽입된 문자중계
     * "GAME_START"
     * "SECOND_START"
     * "GAME_PAUSE"
     * "OVERTIME_START계
     * "SHOOTOUT_START"
     * "GAME_RESUME"
     * "CUT"
     * "SECOND_END"
     * "OVERTIME_END"
     */
    if (
      eventType === 'GAME_START' ||
      eventType === 'HALFTIME' ||
      eventType === 'SECOND_START'
    ) {
      return 'on';
    } else if (eventType === 'FULLTIME') {
      return 'close';
    } else if (eventType === 'SUBSTITUTE') {
      return 'substitute';
    } else {
      return undefined;
    }
  }, [eventType]);

  const ItemDom = (result, eventClass) => (
    <div className={clsx(style.item, !!eventClass && style[eventClass])}>
      <span className={clsx(style.team, style.home)}>
        {!!result.home && result.home}
      </span>
      <span className={style.event}>
        {!!result.time && <em>{result.time}</em>}
      </span>
      <span className={clsx(style.team, style.away)}>
        {!!result.away && result.away}
      </span>
    </div>
  );

  return useMemo(() => {
    const timeArr = displayTime.split(':');
    const time = `${parseInt(timeArr[0]) * 60 + parseInt(timeArr[1])}'`;
    const location = locationType.toLowerCase();

    let elements = [];
    let result = {
      home: undefined,
      away: undefined,
      time
    };

    if (location === 'total') {
      result.home = playText;
      result.away = playText;
    }

    if (_SOCCER_TIME_LINE.hasOwnProperty(eventType)) {
      result.time = _SOCCER_TIME_LINE[eventType];
      elements = [ItemDom(result, eventClass)];
    } else if (
      eventType === 'GOAL' ||
      eventType === 'OWN_GOAL' ||
      eventType === 'PK_SUCCESS' ||
      eventType === 'PK_FAIL'
    ) {
      result[location] = [
        <em className={style.score}>{`(${score.home}-${score.away})`}</em>,
        <em className={style.tx}>{playText}</em>,
        <img
          src={`${
            Url.image
          }score_web/football/event/${eventType.toLowerCase()}.png`}
          alt={eventType.toLowerCase()}
        />
      ];

      if (location === 'away') {
        result[location] = result[location].reverse();
      }

      elements = [ItemDom(result, eventClass)];
    } else if (eventType === 'SUBSTITUTE') {
      let subst = playText.split(',');
      let subOut = [
        <em className={style.tx}>{subst[0]}</em>,
        <img
          src={`${Url.image}score_web/football/event/substitute_out.png`}
          alt="goal"
        />
      ];
      let subIn = [
        <em className={style.tx}>{subst[1]}</em>,
        <img
          src={`${Url.image}score_web/football/event/substitute_in.png`}
          alt="goal"
        />
      ];

      if (location === 'away') {
        subOut = subOut.reverse();
        subIn = subIn.reverse();
      }

      elements = [
        ItemDom({ [location]: subIn, time }, eventClass),
        ItemDom({ [location]: subOut }, eventClass)
      ];
    } else if (
      eventType === 'YELLOW_CARD' ||
      eventType === 'RED_CARD' ||
      eventType === 'YELLOW_TO_RED'
    ) {
      result[location] = [
        <em className={style.tx}>{playText}</em>,
        <img
          src={`${
            Url.image
          }score_web/football/event/${eventType.toLowerCase()}.png`}
          alt={eventType.toLowerCase()}
        />
      ];

      if (location === 'away') {
        result[location] = result[location].reverse();
      }

      elements = [ItemDom(result, eventClass)];
    }

    return elements;
  }, [locationType, playText, eventType, score, eventClass, displayTime]);
};

export default SoccerTimeLineItem;
